<template>
  <form>
    <ui-container>
      <ui-form-section title="Details" subtitle="Provide the main details of the Dispatch Docket in this section."
                       class="py-8 border-b">
        <ui-select-searchable
            label="Package"
            v-if="!packageId"
            placeholder="This DD is related to..."
            v-model="form.package"
            :error="form.errors.get('package_id')"
            :search="searchPackages"
            no-search="Start typing to find packages..."
            class="xl:col-span-6"
        ></ui-select-searchable>
        <ui-select label="Status" name="status_id" v-model="form.status_id" :options="statusOptions"
                   :error="form.errors.get('status_id')" class="xl:col-span-6"></ui-select>
        <ui-select-searchable
            label="Hambro Contact"
            placeholder="Hambro Contact..."
            v-model="form.hambro_contact"
            :error="form.errors.get('hambro_contact_id')"
            :search="searchPeople"
            no-search="Start typing to find people..."
            class="xl:col-span-6"
        ></ui-select-searchable>
        <ui-select-searchable
            label="Site Contact"
            placeholder="Site Contact..."
            v-model="form.site_contact"
            :error="form.errors.get('site_contact_id')"
            :search="searchPeople"
            no-search="Start typing to find people..."
            class="xl:col-span-6"
        ></ui-select-searchable>
        <ui-date-picker label="Requested For / Due" name="due" v-model="form.due" class="xl:col-span-6"
                        placeholder="When is this request due?" :error="form.errors.get('due')"></ui-date-picker>
        <ui-radio label="Delivery / Collection" name="delivery_option" v-model="form.delivery_option"
                  :options="deliverToOptions" :error="form.errors.get('delivery_option')"
                  class="xl:col-span-6"></ui-radio>
        <ui-textarea v-if="showCustomAddress" label="Custom Delivery Address" name="delivery_address"
                     v-model="form.delivery_address" :error="form.errors.get('delivery_address')"
                     class="xl:col-span-6"></ui-textarea>
        <ui-textarea v-else label="Site Address" name="site_address" :disabled="true" v-model="form.site_address"
                     :error="form.errors.get('site_address')" class="xl:col-span-6"></ui-textarea>
        <ui-textarea label="Notes" name="additional" :error="form.errors.get('additional')"
                     v-model="form.additional"></ui-textarea>
      </ui-form-section>
    </ui-container>

    <ui-container>
      <ui-form-section title="Materials" subtitle="Provide the materials requested within this Dispatch Docket."
                       class="py-8 border-b">
        <materials-form label="Materials Request" name="items" v-model="form.items"
                        :error="form.errors.get('items')"></materials-form>
      </ui-form-section>
    </ui-container>

    <ui-container class="py-4 flex justify-end space-x-6">
      <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
      <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
      <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
        {{ editMode ? 'Save' : 'Create' }}
      </ui-button-new>
    </ui-container>
  </form>
</template>

<script>
import {Contact, DispatchDocket, Package} from '@models'

export default {
  props: {
    item: Object,
    edit: Function,
    addItem: Function,
    packageId: null,
  },
  data() {
    const initialData = this.item ? this.item.getFormAttributes() : {status_id: 100, package: {value:this.packageId}}

    return {
      statusOptions: [
        {value: 100, label: 'Pending'},
        {value: 150, label: 'Partially Picked'},
        {value: 200, label: 'Picked'},
        {value: 300, label: 'Dispatched'},
      ],
      deliverToOptions: [
        {value: 'collection', label: 'Collect From Yard'},
        {value: 'site', label: 'To Site'},
        {value: 'custom', label: 'Custom Address'},
      ],
      form: new Form(initialData, async (form) => {
        if (this.editMode) {
          await this.item.update(form.export())
          this.edit(false)
        } else {
          const dispatchDocket = await DispatchDocket.create(form.export())
          this.addItem(dispatchDocket, 0)

          form.reset()
        }
      }),
    }
  },
  methods: {
    async searchPackages(search) {
      return await Package.search(search, true)
    },
    async searchPeople(query) {
      return (await Contact.search(query)).map(x => x.toDropdown())
    },
  },
  computed: {
    showCustomAddress() {
      return this.form.delivery_option === 'custom'
    },
    editMode() {
      return !!this.item
    },
  },
}
</script>
